module.exports = __webpack_public_path__ + "static/img/logo20.6343771b.png";